@if (error) {
  <div  class="error">{{ error }}</div>
}
<div class="commandes-list-container">
  <div class="toolbar">
    <span>Liste des commandes</span>
    <span class="spacer"></span>
    <button type="button" routerLink="/intranet/commandes/creer">Nouvelle commande</button>
  </div>

  <label for="search">Recherche numéro, client ou statut</label>
  <div class="search-row">
    <input id="search" type="text" [(ngModel)]="search" (keyup.enter)="onSearch()" placeholder="Numéro de commande, client, statut">
    <button type="button" (click)="onSearch()">Chercher</button>
  </div>

  <table class="commandes-table">
    <thead>
      <tr>
        <th>Numéro de commande</th>
        <th>Client</th>
        <th>Statut</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (c of commandes; track c.id) {
        <tr>
          <td>{{ c.numero_commande }}</td>
          <td>{{ c.client_identifiant || c.client_id }}</td>
          <td>{{ c.statut }}</td>
          <td class="actions-cell">
            <button type="button" (click)="editCommande(c.id)">Éditer</button>
            <button type="button" (click)="deleteCommande(c.id)">Supprimer</button>
          </td>
        </tr>
      }
    </tbody>
  </table>

  <mat-paginator [length]="total" [pageSize]="pageSize" [pageIndex]="pageIndex" (page)="onPage($event)"></mat-paginator>
</div>
